module.exports = __webpack_public_path__ + "img/guider-bind-btn-en.02f895b5.png";